export const Close = () => {
  return (
    <svg
      width='17'
      height='18'
      viewBox='0 0 17 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.19857 4.89713C3.95504 5.14067 3.96003 5.54322 4.19859 5.78178L7.41418 8.99737L4.19856 12.213C3.96 12.4516 3.95506 12.8541 4.19859 13.0976C4.44213 13.3412 4.84965 13.3412 5.08821 13.1026L8.30383 9.88702L11.5145 13.0976C11.753 13.3362 12.1555 13.3412 12.3991 13.0976C12.6426 12.8541 12.6426 12.4466 12.4041 12.208L9.19345 8.9974L12.4041 5.78678C12.6426 5.54822 12.6426 5.14067 12.3991 4.89713C12.1556 4.6536 11.753 4.65857 11.5144 4.89713L8.3038 8.10775L5.08821 4.89216C4.84964 4.6536 4.4421 4.6536 4.19857 4.89713Z'
        fill='currentColor'
      />
    </svg>
  )
}
